import { Core } from "@faire/design-tokens";
import { Chevron } from "@faire/web/slate/icons/foundation/Chevron";
import { TypographyStyles } from "@faire/web/slate/Typography";
import ClickOutside from "@faire/web/ui/ClickOutside";
import styled, { css } from "styled-components";
export var SelectFieldWrapper = styled(ClickOutside).withConfig({
  displayName: "styles__SelectFieldWrapper"
})(["position:relative;"]);
export var SelectFieldChevron = styled(Chevron).withConfig({
  displayName: "styles__SelectFieldChevron"
})(["position:absolute;right:12px;pointer-events:none;"]);
export var SelectedValue = styled.div.withConfig({
  displayName: "styles__SelectedValue"
})(["padding-left:12px;flex:1;"]);
export var SelectField = styled.div.withConfig({
  displayName: "styles__SelectField"
})(["display:flex;align-items:center;border:1px solid ", ";height:40px;", ""], Core.border.muted, function (_ref) {
  var disabled = _ref.disabled;
  return !disabled ? css(["cursor:pointer;&:hover{border:1px solid ", ";& > svg{color:", ";}}"], Core.border.hover, Core.icon["default"]) : css(["opacity:0.6;"]);
});
export var SearchField = styled.input.withConfig({
  displayName: "styles__SearchField"
})(["", " width:100%;height:100%;padding-left:12px;padding-right:40px;border:none;&:placeholder{color:", ";}&:disabled{background-color:", ";}"], TypographyStyles({}), Core.text.subdued, Core.surface.muted);
export var SelectOptions = styled.div.withConfig({
  displayName: "styles__SelectOptions"
})(["position:absolute;width:100%;max-height:400px;overflow-y:auto;top:40px;left:0;border:1px solid ", ";border-top:none;z-index:1;background-color:", ";"], Core.border.muted, Core.surface.inverse);